import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Box, LinearProgress } from '@mui/material';
import deepmerge from 'deepmerge';

import useNotification from '../../../core/hooks/use_notification';
import { getSuppliersNotificationData } from '../../../core/utils/notification_utils';
import { getSuppliersAction, getSuppliersState } from '../../../features/store/get_suppliers';
import { getDefaultPaginationQueryValues } from '../../../core/utils/api_utils';
import { Button } from '../../common/button';
import PaginationControls from '../../common/pagination_controls';
import SuppliersList from './suppliers_list';
import SuppliersFilters from './filters';
import { ROUTE_SUPPLIERS_NEW } from '../../../core/constants';
import PageHeader from '../../common/page_header';

const initialQueryParams = {
    ...getDefaultPaginationQueryValues,
    query: ''
};

const SuppliersPage = () => {
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();
    const navigate = useNavigate();

    const getSuppliers = useSelector(getSuppliersState);

    const [queryParams, setQueryParams] = useState(initialQueryParams);

    const refreshList = useCallback(() => {
        dispatch(getSuppliersAction(queryParams))
            .then(response => showErrorMessage(getSuppliersNotificationData(response)));
    }, [dispatch, queryParams, showErrorMessage]);

    useEffect(() => {
        refreshList();
    }, [refreshList]);

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3, mb: 4 } }>

            <PageHeader
                title="Zaopatrzeniowcy"
                actions={
                    <Button onClick={ () => navigate(ROUTE_SUPPLIERS_NEW) }>
                        Dodaj zaopatrzeniowca
                    </Button>
                }
            />

            <SuppliersFilters
                onSearchInputChange={ query => setQueryParams(prevState => deepmerge(prevState, { query })) }
            />

            { getSuppliers?.loading && <LinearProgress/> }

            { getSuppliers?.data?.content && (
                <Box sx={ { display: 'flex', flexDirection: 'column', gap: 2 } }>
                    <SuppliersList refreshList={ refreshList }/>

                    <Box sx={ { display: 'flex', justifyContent: 'flex-end', mt: 1 } }>
                        <PaginationControls
                            currentPage={ getSuppliers?.data?.pageable?.pageNumber }
                            totalPages={ getSuppliers?.data?.totalPages }
                            setPage={ page => setQueryParams(prevState => deepmerge(prevState, { page })) }
                        />
                    </Box>
                </Box>
            ) }

        </Box>
    );
};

export default SuppliersPage;